import {
  URL_PROD_YOUR_ACCOUNT,
  URL_STAGING_YOUR_ACCOUNT,
} from "@utils/constants/external-urls";

const buildNextRedirectUrl = (environment, pathName) => {
  const isProduction = environment === "production";
  const appPath = pathName === "/" ? "/conta" : pathName;

  if (isProduction) {
    return URL_PROD_YOUR_ACCOUNT + appPath + "/&origin=magazineluiza";
  } else {
    return URL_STAGING_YOUR_ACCOUNT + appPath + "/&origin=magazineluiza";
  }
};

export default buildNextRedirectUrl;
